"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const novoColorPalette_1 = __importDefault(require("./novoColorPalette"));
const spacing_1 = __importDefault(require("./tokens/spacing"));
const typographySet_1 = require("./tokens/typographySet");
const novoDark = {
    // Tokens
    action01: novoColorPalette_1.default.blue07,
    action02: novoColorPalette_1.default.gray09,
    action03: novoColorPalette_1.default.red06,
    action04: novoColorPalette_1.default.blue06,
    action05: novoColorPalette_1.default.blue07,
    action06: novoColorPalette_1.default.blue05,
    action07: novoColorPalette_1.default.blue10,
    action08: novoColorPalette_1.default.blue08,
    action09: novoColorPalette_1.default.blue07,
    textColor01: novoColorPalette_1.default.white,
    textColor02: novoColorPalette_1.default.gray08,
    textColor04: novoColorPalette_1.default.gray02,
    textColor05: novoColorPalette_1.default.gray08,
    textColor06: novoColorPalette_1.default.white,
    textColor07: novoColorPalette_1.default.gray02,
    textColor08: novoColorPalette_1.default.white,
    textColor09: novoColorPalette_1.default.black,
    textColor10: novoColorPalette_1.default.indigo10,
    error01: novoColorPalette_1.default.red07,
    success01: novoColorPalette_1.default.green04,
    warning01: novoColorPalette_1.default.yellow06,
    warning02: novoColorPalette_1.default.yellow06,
    warning03: novoColorPalette_1.default.yellow03,
    info01: novoColorPalette_1.default.gray05,
    ui01: novoColorPalette_1.default.gray05,
    ui02: novoColorPalette_1.default.gray03,
    ui03: novoColorPalette_1.default.gray06,
    ui04: novoColorPalette_1.default.white,
    ui05: novoColorPalette_1.default.purple02,
    ui06: novoColorPalette_1.default.purple01,
    ui07: novoColorPalette_1.default.gray10,
    ui08: novoColorPalette_1.default.gray09,
    ui09: novoColorPalette_1.default.blue09,
    ui10: novoColorPalette_1.default.gray05,
    ui11: novoColorPalette_1.default.coolgray01,
    ui12: novoColorPalette_1.default.coolgray02,
    ui13: novoColorPalette_1.default.blue03,
    ui14: novoColorPalette_1.default.green03,
    ui15: novoColorPalette_1.default.blue02,
    ui16: novoColorPalette_1.default.red09,
    ui17: novoColorPalette_1.default.yellow11,
    ui18: novoColorPalette_1.default.green09,
    ui19: novoColorPalette_1.default.gray09,
    ui20: novoColorPalette_1.default.violet10,
    ui21: novoColorPalette_1.default.gray08,
    ui22: novoColorPalette_1.default.blue09,
    ui23: novoColorPalette_1.default.indigo03,
    ui24: novoColorPalette_1.default.indigo05,
    ui25: novoColorPalette_1.default.purple01,
    overlay01: `${novoColorPalette_1.default.gray02}BF`,
    shadow01: novoColorPalette_1.default.gray01,
    highlight01: novoColorPalette_1.default.yellow06,
    icon01: novoColorPalette_1.default.white,
    icon02: novoColorPalette_1.default.white,
    icon03: novoColorPalette_1.default.gray05,
    icon04: novoColorPalette_1.default.blue05,
    icon05: novoColorPalette_1.default.gray02,
    icon06: novoColorPalette_1.default.gray05,
    icon07: novoColorPalette_1.default.gray06,
    icon08: novoColorPalette_1.default.gray02,
    // Interactive tokens
    focus01: novoColorPalette_1.default.blue10,
    disabled01: novoColorPalette_1.default.gray08,
    disabled02: novoColorPalette_1.default.gray05,
    disabled03: novoColorPalette_1.default.gray08,
    disabled04: novoColorPalette_1.default.gray06,
    hover01: novoColorPalette_1.default.blue07,
    active01: novoColorPalette_1.default.blue05,
    hover02: novoColorPalette_1.default.gray10,
    active02: novoColorPalette_1.default.gray08,
    hover03: novoColorPalette_1.default.red07,
    active03: novoColorPalette_1.default.red05,
    hover04: novoColorPalette_1.default.green06,
    active04: novoColorPalette_1.default.green04,
    hover05: novoColorPalette_1.default.gray03,
    active05: novoColorPalette_1.default.gray05,
    hover06: novoColorPalette_1.default.gray05,
    hover07: novoColorPalette_1.default.blue08,
    active07: novoColorPalette_1.default.blue05,
    hover08: novoColorPalette_1.default.purple02,
    active08: novoColorPalette_1.default.gray04,
    hover09: novoColorPalette_1.default.gray05,
    active09: novoColorPalette_1.default.gray03,
    hover10: novoColorPalette_1.default.gray02,
    active10: novoColorPalette_1.default.gray03,
    active11: novoColorPalette_1.default.blue09,
    hover11: novoColorPalette_1.default.blue08,
    active12: novoColorPalette_1.default.gray05,
    hover12: novoColorPalette_1.default.gray03,
    hover13: novoColorPalette_1.default.gray04,
    // Data visualisation colors
    data01: novoColorPalette_1.default.magenta07,
    data02: novoColorPalette_1.default.midnight06,
    data03: novoColorPalette_1.default.violet07,
    data04: novoColorPalette_1.default.teal07,
    data05: novoColorPalette_1.default.pink07,
    data06: novoColorPalette_1.default.midnight08,
    data07: novoColorPalette_1.default.magenta06,
    data08: novoColorPalette_1.default.orange07,
    data09: novoColorPalette_1.default.violet06,
    data10: novoColorPalette_1.default.teal06,
    data11: novoColorPalette_1.default.gray06,
    dataText01: novoColorPalette_1.default.gray02,
    dataText02: novoColorPalette_1.default.gray02,
    dataText03: novoColorPalette_1.default.gray02,
    dataText04: novoColorPalette_1.default.black,
    dataText05: novoColorPalette_1.default.black,
    dataText06: novoColorPalette_1.default.black,
    dataText07: novoColorPalette_1.default.white,
    dataText08: novoColorPalette_1.default.black,
    dataText09: novoColorPalette_1.default.white,
    dataText10: novoColorPalette_1.default.white,
    dataText11: novoColorPalette_1.default.black,
    // Alerts
    alertRed: novoColorPalette_1.default.red07,
    alertYellow: novoColorPalette_1.default.yellow06,
    alertGreen: novoColorPalette_1.default.green04,
    // Typography
    label01: typographySet_1.label01,
    labelBold01: typographySet_1.labelBold01,
    body01: typographySet_1.body01,
    bodyBold01: typographySet_1.bodyBold01,
    body02: typographySet_1.body02,
    bodyBold02: typographySet_1.bodyBold02,
    bulletList01: typographySet_1.bulletList01,
    heading01: typographySet_1.heading01,
    heading02: typographySet_1.heading02,
    // Spacing
    spacing01: spacing_1.default.spacing01,
    spacing02: spacing_1.default.spacing02,
    spacing03: spacing_1.default.spacing03,
    spacing04: spacing_1.default.spacing04,
    spacing05: spacing_1.default.spacing05,
    spacing06: spacing_1.default.spacing06,
    spacing07: spacing_1.default.spacing07,
    spacing08: spacing_1.default.spacing08,
    spacing09: spacing_1.default.spacing09,
    // Box Shadows
    shadowLow: `0px 1px 2px 1px ${novoColorPalette_1.default.gray01}`,
    shadowMedium: `0px 2px 8px 2px ${novoColorPalette_1.default.gray01}`,
    shadowHigh: `0px 2px 20px 9px ${novoColorPalette_1.default.gray01}`,
    // User Status
    statusAvailable01: novoColorPalette_1.default.green04,
    statusBusy01: novoColorPalette_1.default.red07,
    statusAway01: novoColorPalette_1.default.orange06,
    statusOffline01: novoColorPalette_1.default.gray05,
    statusWrapup01: novoColorPalette_1.default.violet06,
    brand01: novoColorPalette_1.default.white,
};
exports.default = novoDark;
